'use strict';

$(document).on('click', '.seo-section-display', function () {
    var paragraph = $('.seo-section-paragraph');
    var paragraphInit = $('.seo-section-paragraph-init');
    var chevronUp = $('.fa-seo-section-chevron-up');
    var chevronDown = $('.fa-seo-section-chevron-down');

    if (paragraphInit.length === 0) {
        paragraph.removeClass('seo-section-paragraph').addClass('seo-section-paragraph-init');
    } else if (paragraph.length === 0) {
        paragraphInit.removeClass('seo-section-paragraph-init').addClass('seo-section-paragraph');
    }
    if (chevronUp.length === 0) {
        chevronDown.removeClass('fa-seo-section-chevron-down').addClass('fa-seo-section-chevron-up');
    } else if (chevronDown.length === 0) {
        chevronUp.removeClass('fa-seo-section-chevron-up').addClass('fa-seo-section-chevron-down');
    }
});
